var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pdf',{attrs:{"src":_vm.file.url,"page":_vm.currentPage},on:{"num-pages":function($event){_vm.$parent.pageCount = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }